/* PetPivot FAQ: category filters, "show all" toggle and expand/collapse.
   Labels come from data attributes so they stay editable in the theme editor. */
(function () {
  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function format(template, values) {
    return String(template || '').replace(/\{(\w+)\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function initFaq(root) {
    if (root.getAttribute('data-pp-ready') === 'true') return;
    root.setAttribute('data-pp-ready', 'true');

    var filters = toArray(root.querySelectorAll('[data-faq-filter]'));
    var items = toArray(root.querySelectorAll('.pp-faq-item'));
    var status = root.querySelector('[data-pp-faq-status]');
    var showAll = root.querySelector('[data-pp-faq-show-all]');
    var expand = root.querySelector('[data-pp-faq-expand]');
    var activeCategory = 'all';
    var allVisible = false;

    var statusTemplate = root.getAttribute('data-status-template') || '{visible} of {total} questions';
    var showAllTemplate = root.getAttribute('data-show-all-template') || 'Show all {total}';
    var showEssentialsTemplate = root.getAttribute('data-show-essentials-template') || 'Show {count} essentials';
    var expandLabel = root.getAttribute('data-expand-label') || 'Expand visible';
    var collapseLabel = root.getAttribute('data-collapse-label') || 'Collapse visible';
    var essentials = items.filter(function (item) { return item.getAttribute('data-faq-priority') === 'true'; }).length;

    filters.forEach(function (button) {
      var value = button.getAttribute('data-faq-filter');
      if (value === 'all') return;
      var total = items.filter(function (item) { return item.getAttribute('data-faq-category') === value; }).length;
      if (total === 0) button.hidden = true;
    });

    function update() {
      items.forEach(function (item) {
        var categoryMatch = activeCategory === 'all' || item.getAttribute('data-faq-category') === activeCategory;
        var priorityMatch = activeCategory !== 'all' || allVisible || item.getAttribute('data-faq-priority') === 'true';
        item.hidden = !categoryMatch || !priorityMatch;
        if (item.hidden) item.open = false;
      });
      var visible = items.filter(function (item) { return !item.hidden; }).length;
      if (status) status.textContent = format(statusTemplate, { visible: visible, total: items.length });
      if (showAll) {
        showAll.textContent = activeCategory === 'all' && allVisible
          ? format(showEssentialsTemplate, { count: essentials })
          : format(showAllTemplate, { total: items.length });
      }
      if (expand) expand.textContent = expandLabel;
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        activeCategory = button.getAttribute('data-faq-filter');
        allVisible = false;
        filters.forEach(function (item) { item.classList.remove('is-active'); });
        button.classList.add('is-active');
        update();
      });
    });

    if (showAll) {
      showAll.addEventListener('click', function () {
        if (activeCategory !== 'all') {
          activeCategory = 'all';
          filters.forEach(function (item) {
            item.classList.toggle('is-active', item.getAttribute('data-faq-filter') === 'all');
          });
          allVisible = true;
        } else {
          allVisible = !allVisible;
        }
        update();
      });
    }

    if (expand) {
      expand.addEventListener('click', function () {
        var visible = items.filter(function (item) { return !item.hidden; });
        var shouldOpen = visible.some(function (item) { return !item.open; });
        visible.forEach(function (item) { item.open = shouldOpen; });
        expand.textContent = shouldOpen ? collapseLabel : expandLabel;
      });
    }

    update();
  }

  function initAll(scope) {
    toArray((scope || document).querySelectorAll('[data-pp-faq]')).forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
